import { Modal } from "antd"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { GROLOG_BASE_URL } from "../../constant/apiConstant"
import { setConfirmLeavePage } from "../../store/reducer/page.reducer"
import PrimaryButton from "../button/PrimaryButton"
import SecondaryButton from "../button/SecondaryButton"
import style from './Modal.module.css'
import { doPost } from "../../api/baseAPI";
import { checkValidationToken } from "../../util/errorHandler";
import {
  setIsCompletionAcc,
  setIsWaitingApprove,
  setToken,
} from "../../store/reducer/authentication.reducer";
import { ROUTES } from "../../constant/routeConstant"

const ModalConfirmLeave = (props) =>{
  const navigate = useNavigate()
  const {t} = useTranslation()
  const dispatch = useDispatch()
  const { token } = useSelector((state) => state.auth);

  const leave =()=>{
    dispatch(setConfirmLeavePage(false));
    navigate(props.route)
    props.action()
  }
  const doLogout = async () => {
    const url = `${GROLOG_BASE_URL}oauth/user/logout`;
    let result = { code: undefined, message: false };

    try {
      const response = await doPost(url, token, "");
      if (response) {
        dispatch(setToken());
        dispatch(setIsCompletionAcc());
        dispatch(setIsWaitingApprove());
        navigate(ROUTES.INDEX);
        localStorage.removeItem("auth_code");
        localStorage.removeItem("request_id");
      }
    } catch (error) {
      checkValidationToken(error, token, "", dispatch);
      if (error.response.status === 400) {
        result.code = error.response.status;
        result.message = error.response?.data?.payload?.message;
      }
    }
    return result;
  };

  return(
    <Modal
        visible={props.visible}
        closable={false}
        centered={true}
        width="464px"
        footer={null}
      >
        <div className={style.ModalTitle}>Leave Page?</div>
        <div className={style.ModalSubTitle+" mb-[-20px]"}>
          The change you've been made may not be saves
        </div>

        <div
          style={{
            justifyItems: "center",
            margin: 0,
            padding: 0,
            display: "flex",
          }}
        >
          <div className="mr-8 ml-9">
            <SecondaryButton
              text={t("Leave Page")}
              action={props.iscompletion ? ()=>doLogout :() => leave()}
            />
          </div>

          <PrimaryButton
            text={t("Stay on this page")}
            action={props.stay ? () => props.stay() : () => props.action()}
          />
        </div>
      </Modal>
  )
}

export default ModalConfirmLeave